import { GoogleAnalyticsAdapter } from './google-analytics'
import { GoogleTagManagerAdapter } from './google-tag-manager'
import type { TAnalyticsEvent } from './types'

const isProd = process.env.NODE_ENV === 'production'

const activeAdapters = [GoogleAnalyticsAdapter, GoogleTagManagerAdapter]

export const trackEvent = (event: TAnalyticsEvent) => {
  if (!isProd) {
    return
  }

  activeAdapters.forEach((adapter) => adapter.trackEvent(event))
}
